import { getEntityById, updateEntity, getDocumentHeads, getBankAccounts, getPayoutProfiles } from './financeEntities';
import { createDocumentHead, deleteDocumentHead, updateDocumentHead } from './documentHeads';
import { createBankAccount, deleteBankAccount, updateBankAccount } from './bankAccounts';
import { createPayoutProfile, deletePayoutProfile, updatePayoutProfile } from './payoutProfiles';

export const api = {
    financeEntities: {
        getById: getEntityById,
        update: updateEntity,
        getDocumentHeads,
        getBankAccounts,
        getPayoutProfiles
    },
    documentHeads: {
        create: createDocumentHead,
        update: updateDocumentHead,
        delete: deleteDocumentHead
    },
    bankAccounts: {
        create: createBankAccount,
        update: updateBankAccount,
        delete: deleteBankAccount
    },
    payoutProfiles: {
        create: createPayoutProfile,
        update: updatePayoutProfile,
        delete: deletePayoutProfile
    }
};
